// extracted by mini-css-extract-plugin
module.exports = {"imagePreview":"ImagePreview_imagePreview__1kTNc","defaultImage":"ImagePreview_defaultImage__15wCx"};